import { t } from 'ember-intl';
import { boxMargin, boxPadding } from 'core/modifiers';

const Azure = <template>
  <ol {{boxMargin "0"}}>
    <li
      class="hds-typography-body-200 hds-font-weight-regular hds-foreground-primary"
    >
      {{t
        "components.page.hvn-peerings.create.manual.description.steps.create"
      }}
    </li>
    <li
      class="hds-typography-body-200 hds-font-weight-regular hds-foreground-primary"
      {{boxPadding "xs 0 0 0"}}
    >
      {{t
        "components.page.hvn-peerings.create.manual.description.steps.accept"
        provider=@provider
        htmlSafe=true
      }}
    </li>
    <li
      class="hds-typography-body-200 hds-font-weight-regular hds-foreground-primary"
      {{boxPadding "xs 0 0 0"}}
    >
      {{t
        "components.page.hvn-peerings.create.manual.description.steps.configure"
        provider=@provider
        htmlSafe=true
      }}
    </li>
  </ol>
  {{! TODO:  HCPE-1751 }}
  {{!--
<Typography
  class='hds-typography-body-200 hds-font-weight-regular hds-foreground-primary'
  {{box-margin '0 0 sm 0'}}
>
  {{t
    'components.page.hvn-peerings.create.documentation.learn.azure.title'
  }}
</Typography>
<Hds::Link::Standalone
  @href='https://learn.hashicorp.com/tutorials/cloud/amazon-peering-hcp?in=cloud/networking'
  @icon='docs-link'
  @iconPosition='leading'
  @text={{t
    'components.page.hvn-peerings.create.documentation.learn.aws.title'
  }}
/>
--}}
</template>;
export default Azure;
